export default __webpack_public_path__ + "static/media/email-sent-colored.5a61fdbe.svg";